export function CheckmarkIcon({ color }: { color: string }) {
  return (
    <svg width="16" height="11" viewBox="0 0 12 9" fill="none">
      <path
        d="M1 4.5L4.5 8L11 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
